import { PDFDocument } from "pdf-lib";
import { environment } from "src/environments/environment";

export namespace FileHelper {
  export async function downloadFile(url: string, fileName: string, mimetype: string) {
    const bytes = await fetch(url).then(res => res.arrayBuffer());
    FileHelper.saveByteArray(fileName, bytes, mimetype);
  }

  export function saveByteArray(fileName: string, bytes: BlobPart, mimetype: string) {
    var blob = new Blob([bytes], { type: mimetype });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    // Makes download link open in new tab
    window.open(link.href, "_blank");
  }

  export async function loadPdfDoc(url: string) {
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    return pdfDoc;
  }

  export function switchToCdn(url: string): string {
    if (!url) return url;

    // switch assets from S3 to CloudFront CDN
    if (url.toLowerCase().startsWith(environment.aws.assetsS3Url.toLowerCase())) {
      return environment.aws.assetsCdnUrl + url.substring(environment.aws.assetsS3Url.length);
    }

    return url;
  }

  export function changeFileExt(path: string, ext: string) {
    return path.replace(/\.[^.]+$/, `.${ext}`);
  }
}
